import { Typography } from '@progress/kendo-react-common';
import { Button } from '@progress/kendo-react-buttons';
import { KWELLO_ICON, KwelloSvgIcon } from '../icon/KwelloSvgIcon';
import { Spinner } from '../loader/Spinner';
import { Card, CardBody, CardFooter } from '@progress/kendo-react-layout';
import { TabCardHeader } from './TabCardHeader';
import { FilterParent } from '../../models/filter.model';
import { ALIGNMENT_ROUTES } from 'routes/routes.const';

const ALIGNMENT_URL = ALIGNMENT_ROUTES.summary;

export default function AlignmentTab({
  data,
  isLoading,
  HeaderComponent,
  navigate,
  isTeamMember,
}: any) {
  if (isLoading) {
    return <Spinner />;
  }
  if (data.data.length === 0) {
    return (
      <div className="no-data">
        <KwelloSvgIcon icon={KWELLO_ICON.INFO_ROUNDED_ICON} />
        <Typography.p>No Alignment History</Typography.p>
      </div>
    );
  }
  return (
    <div className="alignment-tab">
      {HeaderComponent}
      <div className="tab-content">
        {data.data.map((row: any, index: number) => {
          const changeScore = row.previousAlignment?.score;
          return (
            <div className="insight-card" key={`${row.surveyName}-${index}`}>
              <Card>
                <TabCardHeader row={row} isTeamMember={isTeamMember} />
                <CardBody>
                  <div className="card-response">
                    <div className="survey">{row.surveyName}</div>
                    <div className="survey">{row.question}</div>
                    <div className="card-response-answer">
                      <Typography.p>{row.answer}</Typography.p>
                    </div>
                    <div
                      className="alignment-box"
                      style={{
                        backgroundColor: row.alignmentColor1,
                        display: 'flex',
                      }}
                    >
                      <div
                        style={{
                          alignItems: 'center',
                        }}
                      >
                        <p
                          className="spark-line-value alignment-value"
                          style={{ color: row.alignmentColor2 }}
                        >
                          {row.alignmentLabel}
                        </p>
                      </div>
                      {changeScore > 0 && (
                        <KwelloSvgIcon
                          icon={KWELLO_ICON.UP_ARROW}
                          className="k-icon k-svg-icon k-button-icon marginRight5 fillGreenColorIcon"
                        />
                      )}
                      {changeScore < 0 && (
                        <KwelloSvgIcon
                          icon={KWELLO_ICON.DOWN_ARROW}
                          className="k-icon k-svg-icon k-button-icon fillRedColorIcon"
                        />
                      )}
                    </div>
                    <div className="response-details">{row.responseDetails}</div>
                  </div>

                  <CardFooter>
                    <KwelloSvgIcon icon={KWELLO_ICON.TAG_OUTLINE_ICON} /> {row.tagCount}
                  </CardFooter>
                </CardBody>
              </Card>
            </div>
          );
        })}
        <div className="panel-footer">
          {/* eslint-disable-next-line @typescript-eslint/no-unsafe-return */}
          <Button
            rounded={'full'}
            onClick={(): void => {
              navigate(ALIGNMENT_URL, true, FilterParent.ALIGNMENT);
            }}
          >
            View All Alignments <KwelloSvgIcon icon={KWELLO_ICON.FILE_FIND} />
          </Button>
        </div>
      </div>
    </div>
  );
}
